import { CheckIcon } from '@heroicons/react/24/outline';
import { NotificationItem } from './NotificationItem';
import {
  useNotifications,
  useMarkNotificationRead,
  useMarkAllNotificationsRead,
} from '../../api/notifications';

interface NotificationDropdownProps {
  onClose: () => void;
}

export function NotificationDropdown({ onClose }: NotificationDropdownProps) {
  const { data, isLoading } = useNotifications({ limit: 10 });
  const markRead = useMarkNotificationRead();
  const markAllRead = useMarkAllNotificationsRead();

  const notifications = data?.data || [];
  const hasUnread = notifications.some((n) => !n.isRead);

  const handleMarkRead = (id: string) => {
    markRead.mutate(id);
  };

  const handleMarkAllRead = () => {
    markAllRead.mutate();
  };

  return (
    <div className="absolute left-0 bottom-full mb-2 w-80 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900">Benachrichtigungen</h3>
        {hasUnread && (
          <button
            onClick={handleMarkAllRead}
            className="text-xs text-primary-600 hover:text-primary-700 flex items-center gap-1"
            disabled={markAllRead.isPending}
          >
            <CheckIcon className="w-3.5 h-3.5" />
            Alle gelesen
          </button>
        )}
      </div>

      {/* Content */}
      <div className="max-h-96 overflow-y-auto">
        {isLoading ? (
          <div className="p-4 text-center text-sm text-gray-500">
            Laden...
          </div>
        ) : notifications.length === 0 ? (
          <div className="p-6 text-center">
            <p className="text-sm text-gray-500">Keine Benachrichtigungen</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {notifications.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onMarkRead={handleMarkRead}
                onClose={onClose}
              />
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      {notifications.length > 0 && (
        <div className="border-t border-gray-200 px-4 py-2">
          <p className="text-xs text-center text-gray-400">
            Zeigt die letzten {notifications.length} Benachrichtigungen
          </p>
        </div>
      )}
    </div>
  );
}
